import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../app/axiosInterceptor';

//hanh trinh xe chay
export const reportSliceBGT = createAsyncThunk(
  'report/reportSliceBGT',
  ({licensePlate = '',groupID='', firstTime = '', lastTime = '', previousId = '', pageSize = 30,action='', agencyId}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/route/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&previousId=${previousId}&pageSize=${pageSize}&action=${action}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//reportTocDocuaXe
export const reportTocDocuaXe = createAsyncThunk(
  'report/reportTocDocuaXe',
  ({licensePlate = '',groupID='', firstTime = '', lastTime = '', previousId = '', pageSize = 30,action='', agencyId}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/speed/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&previousId=${previousId}&pageSize=${pageSize}&action=${action}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//quaTocDoGioiHan
export const quaTocDoGioiHan = createAsyncThunk(
  'report/quaTocDoGioiHan',
  ({licensePlate = '',groupID='', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/overspeed/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//thoiGianLaiXeLientuc
export const thoiGianLaiXeLientuc = createAsyncThunk(
  'report/thoiGianLaiXeLientuc',
  ({type = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/drivetime/data?type=${type}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);


//BaoCaoTongHopTheoXe
export const BaoCaoTongHopTheoXe = createAsyncThunk(
  'report/BaoCaoTongHopTheoXe',
  ({licensePlate = '', groupID='',firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/general/vehicle/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//BaoCaoTongHopTheoLaiXe
export const BaoCaoTongHopTheoLaiXe = createAsyncThunk(
  'report/BaoCaoTongHopTheoLaiXe',
  ({license_number = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/general/driver/data?driverLicense=${license_number}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//BaoCaoDungDo
export const BaoCaoDungDo = createAsyncThunk(
  'report/BaoCaoDungDo',
  ({licensePlate = '', groupID='',firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/stop/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//BaoCaoHinhAnh
export const getBaoCaoHinhAnh = createAsyncThunk(
  'report/BaoCaoHinhAnh',
  ({licensePlate = '', groupID='',firstTime = '', lastTime = '', page = 1, pageSize = 30,  agencyID}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyID}/image/data?licensePlate=${licensePlate}&groupID=&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}&action=`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//license_plate
export const licensePlate = createAsyncThunk(
  'report/licensePlate',
  ({ rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/vehicles/tracking/agency/${localStorage.getItem('agency-id')}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);


//enduser for admin QC 31
export const getEndUserQc31 = createAsyncThunk(
  'report/getEndUserQc31',
  ({id}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/users/get/all/enduser?device_type_id=1&device_type_id=2`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//driver for agency QC 31
export const getDriverQc31 = createAsyncThunk(
  'report/getDriverQc31',
  ({id}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/drivers/agency/${id}?page_size=1000`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//driver for user QC 31
export const getDriverForUserQc31 = createAsyncThunk(
  'report/getDriverQc31',
  ({id}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/drivers/end_user/${id}?page_size=1000`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);


// list license_plate
export const getLicensePlateQc31 = createAsyncThunk(
  'report/getLicensePlateQc31',
  ({id}, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/vehicles/license_plate/qc31/report/${id}?page_size=1000`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

//group_id 
export const groupID = createAsyncThunk(
  'report/groupID',
  ({ rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/group_device/?agency_id=${localStorage.getItem('agency-id')}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
           ,Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const reportSlice = createSlice({
  name: 'report',
  initialState: {
     licensePlateQc: null,
     listDriverQc: null,
     dataLicensePlate:null,
     dataGroupID:null,
     listUserQC31: [],

     dataReportBGT: null,
     dataReportTocDocuaXe:null,
     dataQuaTocDoGioiHan:null,
     dataThoiGianLaiXeLientuc:null,
     dataBaoCaoTongHopTheoXe:null,
     dataBaoCaoTongHopTheoLaiXe:null,
     dataBaoCaoDungDo:null,
     dataBaoCaoHinhAnh:null,

     isLoading : false

  },
  reducers: {
    resetDataSceen: state => {
    state.dataReportBGT= null;
    state.dataReportTocDocuaXe=null;
    state.dataQuaTocDoGioiHan=null;
    state.dataThoiGianLaiXeLientuc=null;
    state.dataBaoCaoTongHopTheoXe=null;
    state.dataBaoCaoTongHopTheoLaiXe=null;
    state.dataBaoCaoDungDo=null;
    state.dataBaoCaoHinhAnh=null;
    state.listDriverQc=null;
    state.licensePlateQc= null;
    },

    resetListLicense: state => {
      state.licensePlateQc= null;
    }
  },
  extraReducers: {

    [reportSliceBGT.pending]: state => {
        state.isLoading= true;
    },
    [reportSliceBGT.fulfilled]: (state, action) => {
       state.dataReportBGT = action.payload;
       state.isLoading= false;
    },
    [reportSliceBGT.rejected]: (state, action) => {
        state.dataReportBGT = null;
        state.isLoading= false;
    },

    /////1 Hanh trinh chay xe


  [reportTocDocuaXe.pending]: state => {
      state.isLoading= true;
  },
  [reportTocDocuaXe.fulfilled]: (state, action) => {
     state.dataReportTocDocuaXe = action.payload;
     state.isLoading= false;
  },
  [reportTocDocuaXe.rejected]: (state, action) => {
      state.dataReportTocDocuaXe = null;
      state.isLoading= false;
  },
  /// 2 reportTocDocuaXe

  [quaTocDoGioiHan.pending]: state => {
      state.isLoading= true;
  },
  [quaTocDoGioiHan.fulfilled]: (state, action) => {
    state.dataQuaTocDoGioiHan = action.payload;
    state.isLoading= false;
  },
  [quaTocDoGioiHan.rejected]: (state, action) => {
      state.dataQuaTocDoGioiHan = null;
      state.isLoading= false;
  },
  /// 3 quaTocDoGioiHan

  [thoiGianLaiXeLientuc.pending]: state => {
    state.isLoading= true;
  },
[thoiGianLaiXeLientuc.fulfilled]: (state, action) => {
  state.dataThoiGianLaiXeLientuc = action.payload;
  state.isLoading= false;
},
[thoiGianLaiXeLientuc.rejected]: (state, action) => {
    state.dataThoiGianLaiXeLientuc = null;
    state.isLoading= false;
},
/// 4 thoiGianLaiXeLientuc

[BaoCaoTongHopTheoXe.pending]: state => {
  state.isLoading= true;
},
[BaoCaoTongHopTheoXe.fulfilled]: (state, action) => {
  state.dataBaoCaoTongHopTheoXe = action.payload;
  state.isLoading= false;
},
[BaoCaoTongHopTheoXe.rejected]: (state, action) => {
  state.dataBaoCaoTongHopTheoXe = null;
  state.isLoading= false;
},
/// 5 BaoCaoTongHopTheoXe

[BaoCaoTongHopTheoLaiXe.pending]: state => {
  state.isLoading= true;
},
[BaoCaoTongHopTheoLaiXe.fulfilled]: (state, action) => {
  state.dataBaoCaoTongHopTheoLaiXe = action.payload;
  state.isLoading= false;
},
[BaoCaoTongHopTheoLaiXe.rejected]: (state, action) => {
  state.dataBaoCaoTongHopTheoLaiXe = null;
  state.isLoading= false;
},
/// 6 BaoCaoTongHopTheoLaiXe

[BaoCaoDungDo.pending]: state => {
  state.isLoading= true;
},
[BaoCaoDungDo.fulfilled]: (state, action) => {
  state.dataBaoCaoDungDo = action.payload;
  state.isLoading= false;
},
[BaoCaoDungDo.rejected]: (state, action) => {
  state.dataBaoCaoDungDo = null;
  state.isLoading= false;
},
///  BaoCaoTongHinhAnh

[getBaoCaoHinhAnh.pending]: state => {
  state.isLoading= true;
},
[getBaoCaoHinhAnh.fulfilled]: (state, action) => {
  state.dataBaoCaoHinhAnh = action.payload;
  state.isLoading= false;
},
[getBaoCaoHinhAnh.rejected]: (state, action) => {
  state.dataBaoCaoHinhAnh = null;
  state.isLoading= false;
},
/// 7 BaoCaoDungDo

  /////licensePlate
  [licensePlate.pending]: state => {
   
  },

  [licensePlate.fulfilled]: (state, action) => {
    state.dataLicensePlate = action.payload.payload.latest_periodics;
    },

  [licensePlate.rejected]: (state, action) => {
    state.dataLicensePlate = null;
     
  },

  [getLicensePlateQc31.pending]: state => {
   
  },

  [getLicensePlateQc31.fulfilled]: (state, action) => {
    state.licensePlateQc = action.payload.payload.result.result;
  },

  [getLicensePlateQc31.rejected]: (state, action) => {
    state.dataLicensePlate = null;
    state.licensePlateQc = [];
  },

  [getDriverQc31.pending]: state => {
   
  },

  [getDriverQc31.fulfilled]: (state, action) => {
    state.listDriverQc = action.payload.payload.drivers;
  },

  [getDriverQc31.rejected]: (state, action) => {
    state.listDriverQc = null;
  },

  [getDriverForUserQc31.pending]: state => {
   
  },

  [getDriverForUserQc31.fulfilled]: (state, action) => {
    state.listDriverQc = action.payload.payload.drivers;
  },

  [getDriverForUserQc31.rejected]: (state, action) => {
    state.listDriverQc = null;
  },
  [getEndUserQc31.pending]: state => {},

  [getEndUserQc31.fulfilled]: (state, action) => {
    state.listUserQC31 = action.payload.payload;
  },

  [getEndUserQc31.rejected]: (state, action) => {
    state.listDriverQc = null;
  },

  /////group_device
  [groupID.pending]: state => {
   
  },

  [groupID.fulfilled]: (state, action) => {
    state.dataGroupID = action.payload.payload.groupDevices;
    },

  [groupID.rejected]: (state, action) => {
    state.dataGroupID = null;
  },

   
  }
});

export const {
  resetDataSceen,
  resetListLicense
} = reportSlice.actions;

export default reportSlice.reducer;
